// const BMIRegex =
//   /^(?:\d[0-9]\-years\-(?:(?:1[01]|[2-9])\-months|1\-month|old)|2\-years\-(?:1[01]|[2-9])\-months|[3-9]\-years\-(?:(?:1[01]|[2-9])\-months|1\-month|old)|2\-year(?:s\-1\-month|\-old))$/;
const BMIRegex =
  /^(?:(?:[2-9]|1[0-9])-years(?:-(?:1[01]|[2-9])-months|-(?:1)-month)?(?:-old)?|(?:2[0-9]|[3-9][0-9]|100)-years-old)$/;
const HeadRegex =
  /^(?:(?:1[01]|[4-9])\-(?:month|week)\-old\-baby|(?:(?:(?:12|[03])|[12])\-week|1\-year)\-old\-baby|(?:2[0-3]\-month|2\-year)\-old|1[3-9]\-month\-old)$/;
const HeightRegex =
  /^(?:\d(?:(?:[01]|2)\-years\-(?:(?:1[01]|[2-9])\-months|1\-month|old)|[3-9]\-(?:years\-(?:(?:1[01]|[2-9])\-months|1\-month|old)|month\-old)|(?:[01]\-month|(?:[01]|2)\-week)\-old\-baby|\-(?:week|year)\-old\-baby)|2\-years\-(?:1[01]|[2-9])\-months|(?:[4-9]|3)\-years\-(?:(?:1[01]|[2-9])\-months|1\-month|old)|(?:[4-9]\-month|(?:(?:2|[4-9])|3)\-week)\-old\-baby|2\-years\-1\-month|(?:2[0-3]\-month|2\-year)\-old)$/;
const WeightRegex =
  /^(?:\d(?:(?:[01]|2)\-years\-(?:(?:1[01]|[2-9])\-months|1\-month|old)|[3-9]\-(?:years\-(?:(?:1[01]|[2-9])\-months|1\-month|old)|month\-old)|(?:[01]\-month|(?:[01]|2)\-week)\-old\-baby|\-(?:week|year)\-old\-baby)|2\-years\-(?:1[01]|[2-9])\-months|(?:[4-9]|3)\-years\-(?:(?:1[01]|[2-9])\-months|1\-month|old)|(?:[4-9]\-month|(?:(?:2|[4-9])|3)\-week)\-old\-baby|2\-years\-1\-month|(?:2[0-3]\-month|2\-year)\-old)$/;
const DefaultPageTItle = {
  url: '/',
  title: 'Growth charts and calculators for the whole family | LifeMeasure',
  description:
    'LifeMeasure has a range of charts and calculators that measure the body, mind and human experience from birth to beyond.',
  content: '',
  canonical: '',
};

export { BMIRegex, HeadRegex, HeightRegex, WeightRegex, DefaultPageTItle };
